import React, {PureComponent} from "react"

import Icon from "@irati/ui/src/Icon"
import {FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import authentication from "@irati/auth"
import {Wallet} from "@irati/types"
import {StyledBalanceCard, IconWrapper} from "./styled"

interface Props {
  rewardWallet: Wallet
}

export default class RewardWalletUsersBalance extends PureComponent<Props> {
  static defaultProps = {
    hideLabel: false
  }
  render() {
    const {rewardWallet} = this.props
    const currency = authentication.defaultUserCurrency()
    return (
      <StyledBalanceCard>
        <IconWrapper>
          <FormattedMessage id="wallet.tenant.refund.rewardWallet" />
          <Icon icon="wallet" />
        </IconWrapper>
        <FormattedCurrency isCents={false} currency={currency} value={rewardWallet.availableBalance} />
      </StyledBalanceCard>
    )
  }
}
